<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 장비명 -->
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC001314')"
						:inputValue="searchParams.mesEqipNm"
						:onChange="value => onChangeSearchParam({ key: 'mesEqipNm', value })"
					/>
				</el-col>
				<!-- 사용장소 -->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001340')"
						paramKey="usePlCd"
						:options="usePlCdList"
						:propData="searchParams.usePlCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 관리번호 -->
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC001317')"
						:inputValue="searchParams.mesEqipNo"
						:onChange="value => onChangeSearchParam({ key: 'mesEqipNo', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/MesEqipNoPopup/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
		//userName: { type: String, default: '' }
	},
	async created() {
		//라인 콤보
		await this.getCommCodes_({ key: 'usePlCdList', codeType: 'OCCU_PL' });
		await this.searchList();
	},
	data() {
		return {
			// userPopupParams: {
			// 	userName: this.userName,
			// 	userId: ''
			// }
		};
	},
	components: { SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getMesEqipNoPopup_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		reset() {
			this.setSearchParam_({ key: 'commCd', value: '' });
		},
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		onChangeSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
		}
	}
};
</script>

<style></style>
